import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';

import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ManualTSService {

  constructor(private http: HttpClient) {

  }

  getListResourceSow() {
    return this.http.get(`${environment.api_cm_manualtimesheet}/listResourceSow`)
      .pipe(map(data => data));
  }

  /**
   *
   * @returns
   */
  getListEpic() {
    return this.http.get(`${environment.api_cm_manualtimesheet}/listEpic`)
      .pipe(map(data => data));
  }

  /**
   * @param parentWorkItemId
   * @returns
   */
  getListTeamFeature(parentWorkItemId: number) {
    let params = new HttpParams();
    params = params.append('parentWorkItemId', parentWorkItemId);
    return this.http.get(`${environment.api_cm_manualtimesheet}/listTeamFeature`, { params: params })
      .pipe(map(data => data));
  }

  /**
   *
   * @returns
   */
  getListTaskType() {
    return this.http.get(`${environment.api_cm_manualtimesheet}/listTaskType`)
      .pipe(map(data => data));
  }

  /**
   *
   * @param param
   * @returns
   */
  saveManualTimeSheet(param: any) {
    return this.http.post(`${environment.api_cm_manualtimesheet}/saveManualTimeSheet`, param )
      .pipe(map(data => data));
  }

  /**
   *
   * @param param
   * @returns
   */
  getListManualTimeSheet(param: any) {
    let params = new HttpParams();
    if (param.filter != null && param.filter?.length > 0) {
      params = params.append('filter', param.filter);
    }
    params = params.append('page', param.pageIndex);
    params = params.append('page_size', param.pageSize);
    return this.http.get(`${environment.api_cm_manualtimesheet}/listManualTimeSheet`, { params: params })
      .pipe(map(data => data));
  }

}
